import React, { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import Main from "./Main";
import About from "./About";
import Contact from "./Contact";
import Gallery from "./Gallery";
import CategoryGallery from "./components/CategoryGallery";
import ScrollToTop from "./components/ScrollToTop";
import './App.css';
import './index.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext'; // Import useLanguage

function AOSInitializer() {
  const location = useLocation();
  const { language } = useLanguage(); // Listen to language changes

  useEffect(() => {
    // 1. Refresh immediately on route change
    AOS.refresh();

    // 2. Refresh again after a short delay (allows React to render new text/layout)
    const timer = setTimeout(() => {
      AOS.refresh();
    }, 300);

    return () => clearTimeout(timer);
  }, [location.pathname, language]); // Re-run when path OR language changes

  // 3. Refresh when the window fully loads (catches late images)
  useEffect(() => {
    const handleLoad = () => AOS.refresh();
    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, []);

  return null;
}

function App() {
  // Disable browser's automatic scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Initialize AOS once globally
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: 'ease-in-out',
      disable: false
    });
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AOSInitializer />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery/:category" element={<CategoryGallery />} />
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </BrowserRouter>
    </div>
    </LanguageProvider>
  );
}

export default App;